import { get, post, remove } from "./api";
import { IAppInfo, IAppInfoDTO, IAppManualDTO } from "../interfaces/dto/app.dto";
import { APIUrl } from "../config/api-url.config";
import { IErrorDto } from "../interfaces/dto/error.dto";
import { AppType } from "../enum/app";

export const searchApp = (search: string, searchMode: string, type: string, token: string, gl: string) =>
  get<{ search: string; type: string ; searchMode: string, gl: string}, Array<IAppInfo> | IErrorDto>(
    APIUrl.searchApp,
    { search, type , searchMode, gl},
    token,
  );

interface IAddApp {
  name: string;
  type: string;
  packageId: string;
  url: string;
  rating: string;
  author: string;
  bundleId: string;
}

export const addApp = (payload: IAddApp, userId: string, token: string) =>
  post<IAddApp, any>(APIUrl.apps(userId), payload, undefined, token);

export const getApps = (userId: string, token: string) =>
  get<{ userId: string }, IAppInfoDTO>(APIUrl.allApps, { userId }, token);

export const deleteApp = (userId: string, id: string, token: string) =>
  remove<undefined, IAppInfoDTO>(APIUrl.app(userId, id), undefined, token);

export const addAppManul = (payload: IAppManualDTO, appType: AppType, userId: string, token: string) =>
  post<{name: string; url: string; appType: AppType }, any>(APIUrl.manulApps(userId), {name: payload.name, url: payload.url, appType}, undefined, token, [payload.thumbnail]);
